import { render, staticRenderFns } from "./FormCommisionsComposition.vue?vue&type=template&id=77addd04&scoped=true&"
import script from "./FormCommisionsComposition.vue?vue&type=script&lang=ts&"
export * from "./FormCommisionsComposition.vue?vue&type=script&lang=ts&"
import style0 from "./FormCommisionsComposition.vue?vue&type=style&index=0&id=77addd04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77addd04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
